export default __webpack_public_path__ + "static/media/main_theme.1863f372.mp3";